import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import theme from 'styles/theme'
import { Body14, Title26 } from 'components/Typography'
import { getBGColor } from 'utils/themeUtils'

export const OfferCardLink = styled.a.attrs({ draggable: false })``
export const OfferCardImage = styled(GatsbyImage)``
export const OfferCardInfoWrapper = styled.div``
export const OfferInfoHeader = styled.div``
export const OfferInfoHeadline = styled(Title26)``
export const OfferInfoCopy = styled(Body14)``

const mobileMaxHeight = '230px'
const mobileMaxWidth = '380px'

export const OfferCardWrapper = styled.div`
  ${OfferCardLink} {
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    user-drag: none;
    -moz-user-select: none;
    -webkit-user-drag: none;

    @media screen and (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
    }

    ${(props) =>
      !props.isSmall &&
      `width: ${mobileMaxWidth};

      ${theme.mediaQueries.medium} {
        flex-direction: row;
        max-height: 325px;
        max-width: 980px;
        text-align: inherit;
        width: 100%;
      }
    `}
  }

  ${OfferCardImage} {
    height: 100%;
    width: 100%;
    flex: 0 0 auto;
    max-height: ${(props) => (props.isOfferGrid ? '325px' : mobileMaxHeight)};
    max-width: ${(props) => (props.isOfferGrid ? '415px' : '100%')};

    @media screen and (max-width: ${theme.breakpoints.md}) {
      max-height: ${mobileMaxHeight};
      ${(props) =>
        !props.isSmall &&
        `max-width: ${mobileMaxWidth}
      `}
    }

    @media screen and (max-width: ${theme.breakpoints.sm}) {
      max-width: none;
    }
  }

  ${OfferCardInfoWrapper} {
    background: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.terciaryFont};
    padding: ${theme.space[6]};

    ${(props) =>
      !props.isSmall &&
      `${theme.mediaQueries.medium} {
        padding: 67px ${theme.space[11]};
        width: 100%;
      }
    `}
  }

  ${OfferInfoHeader} {
    background: rgba(27, 27, 27, 0.35);
    color: ${getBGColor()};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
    left: 0;
    max-height: ${mobileMaxHeight};
    min-height: ${mobileMaxHeight};
    position: absolute;
    right: 0;
    top: 0;

    ${(props) =>
      !props.isSmall &&
      `${theme.mediaQueries.medium} {
        background: none;
        color: inherit;
        display: inherit;
        height: auto;
        max-height: none;
        min-height: auto;
        padding-top: 0;
        position: static;
      }
    `}
  }

  ${OfferInfoHeadline} {
    color: ${theme.colors.sagefeather};
    margin-bottom: ${theme.space[4]};

    ${(props) =>
      !props.isSmall &&
      `${theme.mediaQueries.medium} {
        color: ${props.theme.colors.terciaryFont};
        margin-bottom: 0;

        &::after {
          background-color: ${props.theme.colors.sagemedium};
          content: '';
          display: block;
          height: 1px;
          margin: 16px 0 24px;
          width: ${theme.space[4]};
        }
      }
    `}
  }

  ${OfferInfoCopy} {
    color: ${(props) => props.theme.colors.secondaryFont};
    text-align: center;

    ${(props) =>
      !props.isSmall &&
      `${theme.mediaQueries.medium} {
        text-align: inherit;
      }
    `}
  }
`
